import cn from 'classnames';
import React, {FC, ReactNode} from 'react';

import {TJSXContent} from 'shared/types';

import s from './action-bar.module.less';

interface IActionBarProps {
    children?: TJSXContent | ReactNode;
    side?: 'right' | 'left' | 'center' | 'space-between';
    bordered?: boolean;
    transparent?: boolean;
    className?: string;
}

export const ActionBar: FC<IActionBarProps> = (
    {
        children,
        side = 'left',
        bordered = true,
        transparent = false,
        className,
    }: IActionBarProps,
) => (
    <div className={cn(
        s['action-bar'],
        s[`action-bar_${side}`],
        {[s['action-bar_bordered']]: bordered},
        {[s['action-bar_transparent']]: transparent},
        className,
    )}
    >
        {children}
    </div>
);
